import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class HelperService {
    constructor() { }

    // Example helper function
    formatDate(date: Date): string {
        return date.toLocaleDateString();
    }
}
